/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AddressDetails__AddressFragmentDoc } from '../../features/addresses/Addresses.generated.js';
import { AttachmentSnapshotFragmentDoc, ProductAttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../../features/attachments/Attachments.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrganisationTeamRowFragment = { __typename: 'Team', id: string, name: string, type: string, metadata: any, isActive: boolean, memberCount: number, createdAt: any, updatedAt: any, address?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null };

export type OrganisationTeams_TeamsQueryVariables = Types.Exact<{
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit: Types.Scalars['Int']['input'];
  filters?: Types.InputMaybe<Types.TeamsFilters>;
  sorting?: Types.InputMaybe<Array<Types.TeamsSorting>>;
}>;


export type OrganisationTeams_TeamsQuery = { teams: { __typename: 'MissingCapabilities' } | { __typename: 'TeamConnection', totalCount: number, edges: Array<{ __typename: 'TeamEdge', node: { __typename: 'Team', id: string, name: string, type: string, metadata: any, isActive: boolean, memberCount: number, createdAt: any, updatedAt: any, address?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } }> } };

export type OrganisationTeams_TeamQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type OrganisationTeams_TeamQuery = { team: { __typename: 'MissingCapabilities' } | { __typename: 'Team', id: string, name: string, type: string, metadata: any, isActive: boolean, memberCount: number, createdAt: any, updatedAt: any, members: Array<{ __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, email: any, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }>, address?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } };

export type OrganisationTeams_OrgMembersQueryVariables = Types.Exact<{
  limit: Types.Scalars['Int']['input'];
  sorting: Array<Types.OrganisationMembershipsSorting>;
}>;


export type OrganisationTeams_OrgMembersQuery = { organisationMemberships: { __typename: 'OrganisationMembershipsConnection', edges: Array<{ __typename: 'OrganisationMembershipEdge', node: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, email: any, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } }> } };

export type OrganisationTeams_CreateTeamMutationVariables = Types.Exact<{
  input: Types.CreateTeamInput;
}>;


export type OrganisationTeams_CreateTeamMutation = { createTeam: { __typename: 'CreateTeamResult', team: { __typename: 'Team', id: string, name: string, type: string, metadata: any, isActive: boolean, memberCount: number, createdAt: any, updatedAt: any, address?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } };

export type OrganisationTeams_UpdateTeamMutationVariables = Types.Exact<{
  input: Types.UpdateTeamInput;
}>;


export type OrganisationTeams_UpdateTeamMutation = { updateTeam: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'UpdateTeamResult', team: { __typename: 'Team', id: string, name: string, type: string, metadata: any, isActive: boolean, memberCount: number, createdAt: any, updatedAt: any, address?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } } };

export type OrganisationTeams_DeactivateTeamMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type OrganisationTeams_DeactivateTeamMutation = { deactivateTeam: { __typename: 'DeactivateTeamResult', team: { __typename: 'Team', id: string, name: string, type: string, metadata: any, isActive: boolean, memberCount: number, createdAt: any, updatedAt: any, address?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } };

export type OrganisationTeams_ActivateTeamMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type OrganisationTeams_ActivateTeamMutation = { activateTeam: { __typename: 'ActivateTeamResult', team: { __typename: 'Team', id: string, name: string, type: string, metadata: any, isActive: boolean, memberCount: number, createdAt: any, updatedAt: any, address?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } };

export type OrganisationTeams_AddTeamMembersMutationVariables = Types.Exact<{
  input: Types.AddTeamMembersInput;
}>;


export type OrganisationTeams_AddTeamMembersMutation = { addTeamMembers: { __typename: 'AddTeamMembersResult', team: { __typename: 'Team', id: string, name: string, type: string, metadata: any, isActive: boolean, memberCount: number, createdAt: any, updatedAt: any, address?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } };

export type OrganisationTeams_RemoveTeamMembersMutationVariables = Types.Exact<{
  input: Types.RemoveTeamMembersInput;
}>;


export type OrganisationTeams_RemoveTeamMembersMutation = { removeTeamMembers: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'RemoveTeamMembersResult', team: { __typename: 'Team', id: string, name: string, type: string, metadata: any, isActive: boolean, memberCount: number, createdAt: any, updatedAt: any, address?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } } };

export const OrganisationTeamRowFragmentDoc = gql`
    fragment OrganisationTeamRow on Team {
  id
  name
  type
  metadata
  isActive
  memberCount
  createdAt
  updatedAt
  address {
    ...AddressDetails__Address
  }
}
    ${AddressDetails__AddressFragmentDoc}`;
export const OrganisationTeams_TeamsDocument = gql`
    query OrganisationTeams_Teams($offset: Int, $limit: Int!, $filters: TeamsFilters, $sorting: [TeamsSorting!]) {
  teams(offset: $offset, limit: $limit, filters: $filters, sorting: $sorting) {
    ... on TeamConnection {
      totalCount
      edges {
        node {
          id
          ...OrganisationTeamRow
        }
      }
    }
  }
}
    ${OrganisationTeamRowFragmentDoc}`;

/**
 * __useOrganisationTeams_TeamsQuery__
 *
 * To run a query within a React component, call `useOrganisationTeams_TeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationTeams_TeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationTeams_TeamsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useOrganisationTeams_TeamsQuery(baseOptions: Apollo.QueryHookOptions<OrganisationTeams_TeamsQuery, OrganisationTeams_TeamsQueryVariables> & ({ variables: OrganisationTeams_TeamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationTeams_TeamsQuery, OrganisationTeams_TeamsQueryVariables>(OrganisationTeams_TeamsDocument, options);
      }
export function useOrganisationTeams_TeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationTeams_TeamsQuery, OrganisationTeams_TeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationTeams_TeamsQuery, OrganisationTeams_TeamsQueryVariables>(OrganisationTeams_TeamsDocument, options);
        }
export function useOrganisationTeams_TeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationTeams_TeamsQuery, OrganisationTeams_TeamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationTeams_TeamsQuery, OrganisationTeams_TeamsQueryVariables>(OrganisationTeams_TeamsDocument, options);
        }
export type OrganisationTeams_TeamsQueryHookResult = ReturnType<typeof useOrganisationTeams_TeamsQuery>;
export type OrganisationTeams_TeamsLazyQueryHookResult = ReturnType<typeof useOrganisationTeams_TeamsLazyQuery>;
export type OrganisationTeams_TeamsSuspenseQueryHookResult = ReturnType<typeof useOrganisationTeams_TeamsSuspenseQuery>;
export type OrganisationTeams_TeamsQueryResult = Apollo.QueryResult<OrganisationTeams_TeamsQuery, OrganisationTeams_TeamsQueryVariables>;
export const OrganisationTeams_TeamDocument = gql`
    query OrganisationTeams_Team($id: ID!) {
  team(id: $id) {
    ... on Team {
      id
      ...OrganisationTeamRow
      members {
        id
        firstname
        familyname
        fullname
        email
        avatar {
          ...AttachmentSnapshot
        }
      }
    }
  }
}
    ${OrganisationTeamRowFragmentDoc}
${AttachmentSnapshotFragmentDoc}`;

/**
 * __useOrganisationTeams_TeamQuery__
 *
 * To run a query within a React component, call `useOrganisationTeams_TeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationTeams_TeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationTeams_TeamQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganisationTeams_TeamQuery(baseOptions: Apollo.QueryHookOptions<OrganisationTeams_TeamQuery, OrganisationTeams_TeamQueryVariables> & ({ variables: OrganisationTeams_TeamQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationTeams_TeamQuery, OrganisationTeams_TeamQueryVariables>(OrganisationTeams_TeamDocument, options);
      }
export function useOrganisationTeams_TeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationTeams_TeamQuery, OrganisationTeams_TeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationTeams_TeamQuery, OrganisationTeams_TeamQueryVariables>(OrganisationTeams_TeamDocument, options);
        }
export function useOrganisationTeams_TeamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationTeams_TeamQuery, OrganisationTeams_TeamQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationTeams_TeamQuery, OrganisationTeams_TeamQueryVariables>(OrganisationTeams_TeamDocument, options);
        }
export type OrganisationTeams_TeamQueryHookResult = ReturnType<typeof useOrganisationTeams_TeamQuery>;
export type OrganisationTeams_TeamLazyQueryHookResult = ReturnType<typeof useOrganisationTeams_TeamLazyQuery>;
export type OrganisationTeams_TeamSuspenseQueryHookResult = ReturnType<typeof useOrganisationTeams_TeamSuspenseQuery>;
export type OrganisationTeams_TeamQueryResult = Apollo.QueryResult<OrganisationTeams_TeamQuery, OrganisationTeams_TeamQueryVariables>;
export const OrganisationTeams_OrgMembersDocument = gql`
    query OrganisationTeams_OrgMembers($limit: Int!, $sorting: [OrganisationMembershipsSorting!]!) {
  organisationMemberships(limit: $limit, sorting: $sorting) {
    ... on OrganisationMembershipsConnection {
      edges {
        node {
          id
          firstname
          familyname
          fullname
          email
          avatar {
            ...AttachmentSnapshot
          }
        }
      }
    }
  }
}
    ${AttachmentSnapshotFragmentDoc}`;

/**
 * __useOrganisationTeams_OrgMembersQuery__
 *
 * To run a query within a React component, call `useOrganisationTeams_OrgMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationTeams_OrgMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationTeams_OrgMembersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useOrganisationTeams_OrgMembersQuery(baseOptions: Apollo.QueryHookOptions<OrganisationTeams_OrgMembersQuery, OrganisationTeams_OrgMembersQueryVariables> & ({ variables: OrganisationTeams_OrgMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationTeams_OrgMembersQuery, OrganisationTeams_OrgMembersQueryVariables>(OrganisationTeams_OrgMembersDocument, options);
      }
export function useOrganisationTeams_OrgMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationTeams_OrgMembersQuery, OrganisationTeams_OrgMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationTeams_OrgMembersQuery, OrganisationTeams_OrgMembersQueryVariables>(OrganisationTeams_OrgMembersDocument, options);
        }
export function useOrganisationTeams_OrgMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationTeams_OrgMembersQuery, OrganisationTeams_OrgMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationTeams_OrgMembersQuery, OrganisationTeams_OrgMembersQueryVariables>(OrganisationTeams_OrgMembersDocument, options);
        }
export type OrganisationTeams_OrgMembersQueryHookResult = ReturnType<typeof useOrganisationTeams_OrgMembersQuery>;
export type OrganisationTeams_OrgMembersLazyQueryHookResult = ReturnType<typeof useOrganisationTeams_OrgMembersLazyQuery>;
export type OrganisationTeams_OrgMembersSuspenseQueryHookResult = ReturnType<typeof useOrganisationTeams_OrgMembersSuspenseQuery>;
export type OrganisationTeams_OrgMembersQueryResult = Apollo.QueryResult<OrganisationTeams_OrgMembersQuery, OrganisationTeams_OrgMembersQueryVariables>;
export const OrganisationTeams_CreateTeamDocument = gql`
    mutation OrganisationTeams_CreateTeam($input: CreateTeamInput!) {
  createTeam(input: $input) {
    ... on CreateTeamResult {
      team {
        id
        ...OrganisationTeamRow
      }
    }
  }
}
    ${OrganisationTeamRowFragmentDoc}`;
export type OrganisationTeams_CreateTeamMutationFn = Apollo.MutationFunction<OrganisationTeams_CreateTeamMutation, OrganisationTeams_CreateTeamMutationVariables>;

/**
 * __useOrganisationTeams_CreateTeamMutation__
 *
 * To run a mutation, you first call `useOrganisationTeams_CreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationTeams_CreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationTeamsCreateTeamMutation, { data, loading, error }] = useOrganisationTeams_CreateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganisationTeams_CreateTeamMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationTeams_CreateTeamMutation, OrganisationTeams_CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationTeams_CreateTeamMutation, OrganisationTeams_CreateTeamMutationVariables>(OrganisationTeams_CreateTeamDocument, options);
      }
export type OrganisationTeams_CreateTeamMutationHookResult = ReturnType<typeof useOrganisationTeams_CreateTeamMutation>;
export type OrganisationTeams_CreateTeamMutationResult = Apollo.MutationResult<OrganisationTeams_CreateTeamMutation>;
export type OrganisationTeams_CreateTeamMutationOptions = Apollo.BaseMutationOptions<OrganisationTeams_CreateTeamMutation, OrganisationTeams_CreateTeamMutationVariables>;
export const OrganisationTeams_UpdateTeamDocument = gql`
    mutation OrganisationTeams_UpdateTeam($input: UpdateTeamInput!) {
  updateTeam(input: $input) {
    ... on UpdateTeamResult {
      team {
        id
        ...OrganisationTeamRow
      }
    }
  }
}
    ${OrganisationTeamRowFragmentDoc}`;
export type OrganisationTeams_UpdateTeamMutationFn = Apollo.MutationFunction<OrganisationTeams_UpdateTeamMutation, OrganisationTeams_UpdateTeamMutationVariables>;

/**
 * __useOrganisationTeams_UpdateTeamMutation__
 *
 * To run a mutation, you first call `useOrganisationTeams_UpdateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationTeams_UpdateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationTeamsUpdateTeamMutation, { data, loading, error }] = useOrganisationTeams_UpdateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganisationTeams_UpdateTeamMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationTeams_UpdateTeamMutation, OrganisationTeams_UpdateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationTeams_UpdateTeamMutation, OrganisationTeams_UpdateTeamMutationVariables>(OrganisationTeams_UpdateTeamDocument, options);
      }
export type OrganisationTeams_UpdateTeamMutationHookResult = ReturnType<typeof useOrganisationTeams_UpdateTeamMutation>;
export type OrganisationTeams_UpdateTeamMutationResult = Apollo.MutationResult<OrganisationTeams_UpdateTeamMutation>;
export type OrganisationTeams_UpdateTeamMutationOptions = Apollo.BaseMutationOptions<OrganisationTeams_UpdateTeamMutation, OrganisationTeams_UpdateTeamMutationVariables>;
export const OrganisationTeams_DeactivateTeamDocument = gql`
    mutation OrganisationTeams_DeactivateTeam($id: ID!) {
  deactivateTeam(id: $id) {
    ... on DeactivateTeamResult {
      team {
        id
        ...OrganisationTeamRow
      }
    }
  }
}
    ${OrganisationTeamRowFragmentDoc}`;
export type OrganisationTeams_DeactivateTeamMutationFn = Apollo.MutationFunction<OrganisationTeams_DeactivateTeamMutation, OrganisationTeams_DeactivateTeamMutationVariables>;

/**
 * __useOrganisationTeams_DeactivateTeamMutation__
 *
 * To run a mutation, you first call `useOrganisationTeams_DeactivateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationTeams_DeactivateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationTeamsDeactivateTeamMutation, { data, loading, error }] = useOrganisationTeams_DeactivateTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganisationTeams_DeactivateTeamMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationTeams_DeactivateTeamMutation, OrganisationTeams_DeactivateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationTeams_DeactivateTeamMutation, OrganisationTeams_DeactivateTeamMutationVariables>(OrganisationTeams_DeactivateTeamDocument, options);
      }
export type OrganisationTeams_DeactivateTeamMutationHookResult = ReturnType<typeof useOrganisationTeams_DeactivateTeamMutation>;
export type OrganisationTeams_DeactivateTeamMutationResult = Apollo.MutationResult<OrganisationTeams_DeactivateTeamMutation>;
export type OrganisationTeams_DeactivateTeamMutationOptions = Apollo.BaseMutationOptions<OrganisationTeams_DeactivateTeamMutation, OrganisationTeams_DeactivateTeamMutationVariables>;
export const OrganisationTeams_ActivateTeamDocument = gql`
    mutation OrganisationTeams_ActivateTeam($id: ID!) {
  activateTeam(id: $id) {
    ... on ActivateTeamResult {
      team {
        id
        ...OrganisationTeamRow
      }
    }
  }
}
    ${OrganisationTeamRowFragmentDoc}`;
export type OrganisationTeams_ActivateTeamMutationFn = Apollo.MutationFunction<OrganisationTeams_ActivateTeamMutation, OrganisationTeams_ActivateTeamMutationVariables>;

/**
 * __useOrganisationTeams_ActivateTeamMutation__
 *
 * To run a mutation, you first call `useOrganisationTeams_ActivateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationTeams_ActivateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationTeamsActivateTeamMutation, { data, loading, error }] = useOrganisationTeams_ActivateTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganisationTeams_ActivateTeamMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationTeams_ActivateTeamMutation, OrganisationTeams_ActivateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationTeams_ActivateTeamMutation, OrganisationTeams_ActivateTeamMutationVariables>(OrganisationTeams_ActivateTeamDocument, options);
      }
export type OrganisationTeams_ActivateTeamMutationHookResult = ReturnType<typeof useOrganisationTeams_ActivateTeamMutation>;
export type OrganisationTeams_ActivateTeamMutationResult = Apollo.MutationResult<OrganisationTeams_ActivateTeamMutation>;
export type OrganisationTeams_ActivateTeamMutationOptions = Apollo.BaseMutationOptions<OrganisationTeams_ActivateTeamMutation, OrganisationTeams_ActivateTeamMutationVariables>;
export const OrganisationTeams_AddTeamMembersDocument = gql`
    mutation OrganisationTeams_AddTeamMembers($input: AddTeamMembersInput!) {
  addTeamMembers(input: $input) {
    ... on AddTeamMembersResult {
      team {
        id
        ...OrganisationTeamRow
      }
    }
  }
}
    ${OrganisationTeamRowFragmentDoc}`;
export type OrganisationTeams_AddTeamMembersMutationFn = Apollo.MutationFunction<OrganisationTeams_AddTeamMembersMutation, OrganisationTeams_AddTeamMembersMutationVariables>;

/**
 * __useOrganisationTeams_AddTeamMembersMutation__
 *
 * To run a mutation, you first call `useOrganisationTeams_AddTeamMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationTeams_AddTeamMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationTeamsAddTeamMembersMutation, { data, loading, error }] = useOrganisationTeams_AddTeamMembersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganisationTeams_AddTeamMembersMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationTeams_AddTeamMembersMutation, OrganisationTeams_AddTeamMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationTeams_AddTeamMembersMutation, OrganisationTeams_AddTeamMembersMutationVariables>(OrganisationTeams_AddTeamMembersDocument, options);
      }
export type OrganisationTeams_AddTeamMembersMutationHookResult = ReturnType<typeof useOrganisationTeams_AddTeamMembersMutation>;
export type OrganisationTeams_AddTeamMembersMutationResult = Apollo.MutationResult<OrganisationTeams_AddTeamMembersMutation>;
export type OrganisationTeams_AddTeamMembersMutationOptions = Apollo.BaseMutationOptions<OrganisationTeams_AddTeamMembersMutation, OrganisationTeams_AddTeamMembersMutationVariables>;
export const OrganisationTeams_RemoveTeamMembersDocument = gql`
    mutation OrganisationTeams_RemoveTeamMembers($input: RemoveTeamMembersInput!) {
  removeTeamMembers(input: $input) {
    ... on RemoveTeamMembersResult {
      team {
        id
        ...OrganisationTeamRow
      }
    }
  }
}
    ${OrganisationTeamRowFragmentDoc}`;
export type OrganisationTeams_RemoveTeamMembersMutationFn = Apollo.MutationFunction<OrganisationTeams_RemoveTeamMembersMutation, OrganisationTeams_RemoveTeamMembersMutationVariables>;

/**
 * __useOrganisationTeams_RemoveTeamMembersMutation__
 *
 * To run a mutation, you first call `useOrganisationTeams_RemoveTeamMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationTeams_RemoveTeamMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationTeamsRemoveTeamMembersMutation, { data, loading, error }] = useOrganisationTeams_RemoveTeamMembersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganisationTeams_RemoveTeamMembersMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationTeams_RemoveTeamMembersMutation, OrganisationTeams_RemoveTeamMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationTeams_RemoveTeamMembersMutation, OrganisationTeams_RemoveTeamMembersMutationVariables>(OrganisationTeams_RemoveTeamMembersDocument, options);
      }
export type OrganisationTeams_RemoveTeamMembersMutationHookResult = ReturnType<typeof useOrganisationTeams_RemoveTeamMembersMutation>;
export type OrganisationTeams_RemoveTeamMembersMutationResult = Apollo.MutationResult<OrganisationTeams_RemoveTeamMembersMutation>;
export type OrganisationTeams_RemoveTeamMembersMutationOptions = Apollo.BaseMutationOptions<OrganisationTeams_RemoveTeamMembersMutation, OrganisationTeams_RemoveTeamMembersMutationVariables>;